import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import logo from "../../assets/logo.png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-navy text-sand overflow-hidden">
      <div className="grain-overlay" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid gap-14 md:grid-cols-6">
          <div className="md:col-span-2">
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-white rounded-lg p-2 shadow-sm ring-1 ring-gold/30">
                <img src={logo} alt="SVS College of Nursing — Care, Compassion, Commitment" className="h-20 w-auto object-contain" />
              </div>
              <div>
                <div className="font-serif text-2xl">SVS College of Nursing</div>
                <div className="text-xs tracking-[0.28em] text-gold uppercase">Bokaro · Jharkhand</div>
              </div>
            </div>
            <p className="text-sand/70 max-w-md leading-relaxed">
              Nurturing skilled, compassionate and competent healthcare professionals through
              excellence in ANM, GNM and B.Sc Nursing education.
            </p>
          </div>

          <div>
            <h4 className="text-gold text-sm tracking-[0.2em] uppercase mb-5">Explore</h4>
            <ul className="space-y-3 text-sand/80">
              {[["Home", "/"], ["About", "/about"], ["Programs", "/courses"], ["Placements", "/placements"], ["Gallery", "/gallery"], ["Blog", "/blog"]].map(
                ([l, to]) => (
                  <li key={to}>
                    <Link to={to} className="hover:text-gold transition-colors duration-300">{l}</Link>
                  </li>
                )
              )}
            </ul>
          </div>

          <div>
            <h4 className="text-gold text-sm tracking-[0.2em] uppercase mb-5">Admissions</h4>
            <ul className="space-y-3 text-sand/80">
              {[
                ["Apply Now", "/admissions"],
                ["Fees", "/admissions/fees"],
                ["Eligibility", "/admissions/eligibility"],
                ["B.Sc. Nursing", "/programs/bsc-nursing"],
                ["GNM", "/programs/gnm"],
                ["ANM", "/programs/anm"],
              ].map(([l, to]) => (
                <li key={to}>
                  <Link to={to} className="hover:text-gold transition-colors duration-300">{l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-gold text-sm tracking-[0.2em] uppercase mb-5">Locations</h4>
            <ul className="space-y-3 text-sand/80">
              {[
                ["Near Dhanbad", "/nursing-college-in-dhanbad"],
                ["Near Ranchi", "/nursing-college-in-ranchi"],
              ].map(([l, to]) => (
                <li key={to}>
                  <Link to={to} className="hover:text-gold transition-colors duration-300">{l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-gold text-sm tracking-[0.2em] uppercase mb-5">Contact</h4>
            <ul className="space-y-4 text-sand/80 text-sm">
              <li className="flex gap-3"><MapPin size={18} className="text-gold shrink-0 mt-0.5" /> Bahadurpur, Jainamore, Bokaro, Jharkhand</li>
              <li className="flex gap-3"><Phone size={18} className="text-gold shrink-0 mt-0.5" /><a href="tel:+917091355794" className="hover:text-gold">+91 70913 55794</a></li>
              <li className="flex gap-3"><Phone size={18} className="text-gold shrink-0 mt-0.5" /><a href="tel:+917992299796" className="hover:text-gold">+91 79922 99796</a></li>
              <li className="flex gap-3"><Mail size={18} className="text-gold shrink-0 mt-0.5" /><a href="mailto:svscollegeofnursing@gmail.com" className="hover:text-gold break-all">svscollegeofnursing@gmail.com</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sand/50 text-sm">
          <p>© {new Date().getFullYear()} SVS College of Nursing. All rights reserved.</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-gold transition-colors">Admin Login</Link>
        </div>
      </div>
    </footer>
  );
}
